import { Link, useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { imgUrl } from "@/lib/api";
import { categoryName } from "@/lib/constants";

export default function ProductCard({ product }) {
  const navigate = useNavigate();
  return (
    <div className="group flex flex-col bg-white border border-gold/10 hover:border-gold/30 transition-colors duration-500 overflow-hidden">
      <Link to={`/product/${product.id}`} className="block overflow-hidden aspect-[4/5] relative">
        <img
          src={imgUrl(product.image)}
          alt={product.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        {product.featured && (
          <span className="absolute top-4 left-4 bg-ink/85 text-gold font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5 backdrop-blur">
            Featured
          </span>
        )}
      </Link>
      <div className="flex flex-col flex-1 p-6">
        <p className="eyebrow mb-2">{categoryName(product.category)}</p>
        <Link to={`/product/${product.id}`}>
          <h3 className="font-serif text-xl sm:text-2xl font-medium text-ink group-hover:text-gold-brass transition-colors duration-300">
            {product.name}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-ink-muted leading-relaxed line-clamp-2">{product.tagline}</p>
        <div className="mt-auto pt-5 flex items-center justify-between gap-3">
          <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-ink/50">
            MOQ {product.moq}
          </span>
          <button
            data-testid="product-card-request-quote-button"
            onClick={() => navigate(`/enquire?product=${product.id}`)}
            className="inline-flex items-center gap-1.5 text-sm text-gold-brass gold-underline-btn font-medium"
          >
            Request Quote <ArrowUpRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
